import { FlashAlertsManager } from "@/modules/flash_alerts";
import { useEditorStore } from "@/stores/editor_store";

export const useFlashAlertsManager = () => {
  const store = useEditorStore();
  const flashAlertsManager = new FlashAlertsManager(store.flashAlerts);
  return { flashAlertsManager };
};
